import { AuthProvider } from "@/lib/auth/types";

export const KNOWN_PROVIDERS: readonly AuthProvider[] = [
  "clerk",
  "keycloak",
  "oidc",
  "dummy",
];

/** True for the provider values served by the shared Auth.js OIDC module. */
export function isOidcProvider(provider: AuthProvider): boolean {
  return provider === "keycloak" || provider === "oidc";
}

/** Narrow an arbitrary string to a known provider, or null. */
export function normalizeAuthProvider(
  value: string | undefined | null,
): AuthProvider | null {
  return KNOWN_PROVIDERS.includes(value as AuthProvider)
    ? (value as AuthProvider)
    : null;
}

/**
 * The configured identity provider, read from the environment.
 *
 * AUTH_PROVIDER first, NEXT_PUBLIC_AUTH_PROVIDER second, and the order is the
 * whole point: the non-public name is readable at RUNTIME on the server, so a
 * single image can serve environments running different providers. The
 * NEXT_PUBLIC_ name is inlined into the client bundle at build time and exists
 * only as a fallback.
 *
 * Deliberately NOT a client module. Server code — middleware, getAccount, the
 * root layout — calls this directly. Client components must use
 * useAuthProviderName() instead: a browser cannot see AUTH_PROVIDER at all, so
 * calling this there silently falls back to whatever was baked into the bundle,
 * which is exactly the bug this indirection exists to remove.
 */
export function getAuthProvider(): AuthProvider {
  return (
    normalizeAuthProvider(process.env.AUTH_PROVIDER) ??
    normalizeAuthProvider(process.env.NEXT_PUBLIC_AUTH_PROVIDER) ??
    "clerk"
  );
}
